import addRoute from '@/router/add-route';


const DataExports = () => import('@/modules/data-exports/data-exports');
const DataExportForm = () => import('@/modules/data-exports/data-export-form');

const routes = [
    addRoute({
        name: 'data-exports',
        path: '/data-exports/',
        component: DataExports,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'add-data-export',
        path: '/data-exports/add',
        component: DataExportForm,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'update-data-export',
        path: '/data-exports/update/:id',
        component: DataExportForm,
        root: {label: 'Automations', name: 'automations'},
    }),
];

export default routes;
